import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Utente } from 'src/app/entities/various';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ToastComponent } from '../inside/utils/toast/toast.component';
import { UtenteService } from 'src/app/services/users/utente.service';

@Component({
  selector: 'app-registrazione',
  templateUrl: './registrazione.component.html',
  styleUrls: ['./registrazione.component.css']
})
export class RegistrazioneComponent implements OnInit {

  @ViewChild('toast', { static: false }) toast  : ToastComponent | undefined;

  utente: Utente;
  condizioni: boolean = false;

  constructor(
    public router: Router,
    private utenteService: UtenteService,
    public toastService: ToastService
  ) { 
    this.utente = {
      user_id: 0,
      email: '',
      is_active: 'f',
      created_at: '',
      last_login: '',
      indirizzo: '',
      comune: '',
      provincia: '',
      cap: '',
      nazione: '',
      denominazione: '',
      codice_fiscale: '',
      partita_iva: '',
      regime_fiscale: '',
      pec: '',
      iban_list: '',
      password_hash: null,
      id_admin: null
    };
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.toastService.setToastComponent(this.toast!);
  }

  index() {
    this.router.navigate(['/Login']);
  }

  async controllaPiva(event: any)
  {
    await this.utenteService.controlloPartitaIva(event.target.value).then(
      (resp) => {
        if (resp.success || resp.data.name != '---') {
          this.utente.denominazione = resp.data.name;
          this.utente.nazione = resp.data.countryCode;
          let indirizzo = ((resp.data.address).replace("\n", '')).split(' ');
          let reversedIndirizzo = [...indirizzo].reverse();
          const [provincia, comune, cap, ...resto] = reversedIndirizzo;
          const indirizzoCompleto = resto.reverse().join(" ");
          this.utente.provincia = provincia;
          this.utente.comune = comune;
          this.utente.cap = cap;
          this.utente.indirizzo = indirizzoCompleto;
        } else {
          this.toastService.openToastWithConfig(true, 5000, "Partita IVA non riconosciuta, inserisci manualmente i campi anagrafici", "warning");
        }
      }
    );
    
  }

  registrazione() {
    let campiok: boolean = true;
    let errorMessages: string[] = [];
    // controllo se i campi obbligatori ci sono
    if (this.utente.email == "") {
      errorMessages.push("Email non inserita.");
      campiok = false;
    }
    if (this.utente.denominazione == "") {
      errorMessages.push("Denominazione non inserita");
      campiok = false;
    }
    if (this.utente.partita_iva == "") {
      errorMessages.push("Partita IVA non inserita");
      campiok = false;
    }
    if (this.utente.indirizzo == "") {
      errorMessages.push("Indirizzo non inserito");
      campiok = false;
    }
    if (this.utente.cap == "") {
      errorMessages.push("CAP non inserito");
      campiok = false;
    }
    if (this.utente.comune == "") {
      errorMessages.push("Comune non inserito");
      campiok = false;
    }
    if (this.utente.provincia == "") {
      errorMessages.push("Provincia non inserito");
      campiok = false;
    } else {
      this.utente.provincia = this.utente.provincia.replace('\n', '');
    }
    if (this.utente.nazione == "") {
      errorMessages.push("Nazione non inserita");
      campiok = false;
    }
    if (this.condizioni == false) {
      errorMessages.push("Termini e condizioni non accettati");
      campiok = false;
    }

    if (!campiok) {
      const fullMessage = errorMessages.join('\n');
      this.toastService.openToastWithConfig(false, 10000, fullMessage, "error");
      return
    } else {
      // procedo con il salvataggio utente
      this.utenteService.registraUtente(this.utente).then(
        (res) => {
          if (res.success) {
            this.toastService.openToastWithConfig(false, 10000, "Utente registrato correttamente, verificare la mail per l'attivazione", "success");
            this.router.navigate(['/Login']);
          }
        }
      );
    }
  }

}
